import React from "react";
// Comps
import { IonPage } from "@ionic/react";
import MarginContainer from "components/common/MarginContainer/MarginContainer";
import Logo from "components/common/Logo/Logo";
import Menu from "components/pages/Home/Menu/Menu";
// Css
import classes from "./Home.module.scss";

const Home: React.FC = () => {
  return (
    <IonPage>
      <MarginContainer className={classes.container} hasBackBtn={false}>
        <Logo maxWidth="250px" />
        <Menu />
      </MarginContainer>
    </IonPage>
  );
};

export default Home;
